import moment from 'moment'

export const formatTime = (epochSeconds: number | null | undefined): string =>
	epochSeconds == null ? '—' : moment(epochSeconds * 1000).format('HH:mm')

export const formatRange = (from: number, to: number): string => `${formatTime(from)}–${formatTime(to)}`
